import { red } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';
export const primaryColor = 'rgba(0,114,206,255)';
const theme = createTheme({
  palette: {
    primary: {
      main: primaryColor,
    },
    secondary: {
      main: '#FF6200',
    },
    error: {
      main: red.A400,
    },
  },
});

export default theme;
